import { Component,HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-vendor-app',
  templateUrl: './vendor-app.component.html',
  styleUrls: ['./vendor-app.component.scss']
})
export class VendorAppComponent {
isSidebarOpen = false;
  isAdmin = true; // set to false to hide admin-only sections
  isNavbarCollapsed = true;

  constructor(private router: Router) {
    // close mobile offcanvas when route fragment navigation completes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.closeSidebar();
      }
    });
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  // Optional: close offcanvas when clicking ESC
  @HostListener('document:keydown.escape', ['$event'])
  onEsc(event: KeyboardEvent) {
    this.closeSidebar();
  }

    toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

   goToUploadScreen() {
  this.router.navigate(['/product-upload']).then(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
}
